// noinspection DuplicatedCode

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useController } from 'react-hook-form';

const propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(Object),
  block: PropTypes.bool,
};
const defaultProps = {
  disabled: false,
  options: [],
  block: false,
};

export function Select(props) {
  const { label, name, disabled, options, block } = props;
  const { field, formState } = useController(props);

  const checkIfErrorsExists = (obj) =>
    !!(obj && obj.errors[name] && Object.keys(obj.errors[name]).length);

  const renderSelect = () => (
    <>
      <select
        {...field}
        className={classNames('form-select', {
          'is-invalid': checkIfErrorsExists(formState),
        })}
        id={name}
        disabled={disabled}
        name={name}
      >
        <option value="" aria-label='Space'>&nbsp;</option>
        {options.map(({ value, label: optionLabel }) => (
          <option key={`${name}-option-${value}`} value={value} aria-label={optionLabel}>
            {optionLabel}
          </option>
        ))}
      </select>
      <div
        className={classNames('invalid-feedback', {
          show: checkIfErrorsExists(formState),
        })}
      >
        {formState.errors[name]?.type === 'required' && `${label} is required`}
      </div>
    </>
  );

  return (
    <div className="form select">
      {!block ? (
        <Row>
          <Col sm={12} xl={3} md={3} className="label-container">
            <label htmlFor={name} className="col-form-label" aria-label={label}>
              {label}
            </label>
          </Col>
          <Col sm={12} xl={9} md={9} className="field-container">
            {renderSelect()}
          </Col>
        </Row>
      ) : (
        <>
          <div className="d-block label-container">
            <label htmlFor={name} className="col-form-label" aria-label={label}>
              {label}
            </label>
          </div>
          <div className="d-block field-container">{renderSelect()}</div>
        </>
      )}
    </div>
  );
}

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
